(() => {
  function activateMood(section,key,focus=false){
    section.querySelectorAll('[data-mood-tab]').forEach(tab=>{const selected=tab.dataset.moodTab===key;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;if(selected&&focus)tab.focus();});
    section.querySelectorAll('[data-mood-panel]').forEach(panel=>panel.hidden=panel.dataset.moodPanel!==key);
  }
  function init(root=document){
    root.querySelectorAll('[data-moods]').forEach(section=>{
      if(section.dataset.moodReady)return;section.dataset.moodReady='true';
      const tabs=[...section.querySelectorAll('[data-mood-tab]')];
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>activateMood(section,tab.dataset.moodTab));
        tab.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight')next=(i+1)%tabs.length;else if(event.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();activateMood(section,tabs[next].dataset.moodTab,true)});
      });
    });
    root.querySelectorAll('[data-latest-reels]').forEach(track=>{
      const cards=[...track.querySelectorAll(':scope>.reel-card')];
      cards.sort((a,b)=>(Date.parse(b.dataset.published)||0)-(Date.parse(a.dataset.published)||0));
      const follow=track.querySelector(':scope>.reel-follow');
      cards.forEach((card,index)=>{card.hidden=index>=6;track.insertBefore(card,follow)});
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-mood-panel]');if(panel)activateMood(panel.closest('[data-moods]'),panel.dataset.moodPanel)});
  document.addEventListener('submit',event=>{const form=event.target.closest('[data-demo-newsletter]');if(!form)return;event.preventDefault();form.querySelector('[data-newsletter-result]').hidden=false;});
})();

(() => {
  function update(control){
    const input=control.querySelector('[name="quantity"]');if(!input)return;
    const min=Number(input.min)||1,step=Number(input.step)||1,rawMax=input.max===''?Infinity:Number(input.max),max=Number.isFinite(rawMax)?min+Math.floor((rawMax-min)/step)*step:Infinity,value=Number(input.value);
    control.querySelector('[data-quantity-step="-1"]').disabled=!Number.isFinite(value)||value<=min;
    control.querySelector('[data-quantity-step="1"]').disabled=!Number.isFinite(value)||value>=max;
  }
  function init(root=document){root.querySelectorAll('.quantity-control').forEach(update);}
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-quantity-step]');if(!button){if(e.target.closest('[data-quick],[data-quick-template]'))queueMicrotask(()=>init());return;}
    const control=button.closest('.quantity-control'),input=control.querySelector('[name="quantity"]');
    const min=Number(input.min)||1,step=Number(input.step)||1,max=input.max===''?Infinity:Number(input.max),value=Number(input.value)||min;
    const slot=Math.round((value-min)/step)+Number(button.dataset.quantityStep),next=Math.min(Number.isFinite(max)?min+Math.floor((max-min)/step)*step:Infinity,min+Math.max(0,slot)*step);
    input.value=String(next);input.dispatchEvent(new Event('change',{bubbles:true}));update(control);
  });
  document.addEventListener('input',e=>{const c=e.target.closest('.quantity-control');if(c)update(c);});
  document.addEventListener('change',e=>{const c=e.target.closest('.quantity-control');if(c)update(c);if(e.target.matches('[data-variant-option],[data-demo-variant],[data-variant-select]'))queueMicrotask(()=>init(e.target.closest('form')));});
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

(() => {
  function setup(root=document){root.querySelectorAll('.collection-swatch-track').forEach(track=>{
    if(track.dataset.dragReady)return;track.dataset.dragReady='true';let start=0,scroll=0,drag=false,pointer=null,suppress=false;
    track.addEventListener('dragstart',e=>e.preventDefault());
    track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;pointer=e.pointerId;start=e.clientX;scroll=track.scrollLeft;drag=false;suppress=false;});
    track.addEventListener('pointermove',e=>{if(pointer!==e.pointerId)return;const delta=e.clientX-start;if(Math.abs(delta)>5&&!drag){drag=true;track.setPointerCapture(e.pointerId);track.classList.add('is-dragging');}if(drag){e.preventDefault();track.scrollLeft=scroll-delta;}});
    const end=e=>{if(pointer!==e.pointerId)return;suppress=drag;pointer=null;drag=false;track.classList.remove('is-dragging');if(track.hasPointerCapture(e.pointerId))track.releasePointerCapture(e.pointerId);};
    track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('pointerleave',e=>{if(!drag)pointer=null;});
    track.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopPropagation();suppress=false;}},true);
  });}
  document.addEventListener('DOMContentLoaded',()=>setup());document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
(() => {
function setup(root=document){root.querySelectorAll('[data-tier-guide]').forEach(guide=>{if(guide.dataset.tierReady)return;guide.dataset.tierReady='true';const tabs=[...guide.querySelectorAll('[data-tier-tab]')];if(!tabs.length)return;function select(tab){tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});guide.querySelectorAll('[data-tier-panel]').forEach(p=>p.hidden=p.dataset.tierPanel!==tab.dataset.tierTab);}tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=tabs[(index+1)%tabs.length];else if(e.key==='ArrowLeft')next=tabs[(index-1+tabs.length)%tabs.length];else if(e.key==='Home')next=tabs[0];else if(e.key==='End')next=tabs.at(-1);if(next){e.preventDefault();select(next);next.focus();}});});select(tabs[0]);});}
document.addEventListener('DOMContentLoaded',()=>setup());document.addEventListener('shopify:section:load',e=>setup(e.target));
})();

(() => {
  const setups = new WeakMap();
  function init(root = document) {
    const forms = [...root.querySelectorAll('form[data-purchase-ui]')];
    if (root.matches?.('form[data-purchase-ui]')) forms.unshift(root);
    forms.forEach(form => {
      if (setups.has(form)) return;
      const primary = form.querySelector('.purchase-row [name="add"]');
      if (!primary) return;
      const dock = form.querySelector('[data-purchase-dock]');
      let format, wholeFormat;
      try { format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:form.dataset.currency || 'USD'}); wholeFormat = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:form.dataset.currency || 'USD',minimumFractionDigits:0,maximumFractionDigits:0}); } catch {}
      const sync = () => {
        const selected = form.querySelector('[data-variant-option]:checked,[data-demo-variant]:checked') || form.querySelector('[data-variant-select]')?.selectedOptions[0];
        const title = selected?.closest('.edition-option')?.querySelector('.edition-tile>strong')?.textContent || selected?.textContent || form.dataset.defaultTitle || '';
        const available = selected ? selected.dataset.available === 'true' : form.dataset.available === 'true';
        const quantity = form.querySelector('[name="quantity"]');
        const count = Number(quantity?.value) || Number(quantity?.min) || 1;
        const minor = Number(selected?.dataset.priceMinor ?? form.dataset.priceMinor);
        const total = format && Number.isFinite(minor) ? (form.classList.contains('photo-weight-form') && Number.isInteger(minor * count / 100) ? wholeFormat : format).format(minor * count / 100) : '';
        form.querySelectorAll('[data-purchase-selection]').forEach(el => el.textContent = title);
        form.querySelectorAll('[data-purchase-total]').forEach(el => { el.textContent = total; el.hidden = !available || !total; });
        const stock = form.querySelector('[data-purchase-stock]');
        if (stock) { stock.dataset.available = String(available); stock.textContent = available ? form.dataset.availableLabel : form.dataset.soldLabel; }
        if (dock) {
          dock.querySelector('[data-dock-detail]').textContent = [count > 1 ? count + ' × ' + title : title, total].filter(Boolean).join(' · ');
          const button = dock.querySelector('button');
          button.disabled = primary.disabled || !available;
          button.setAttribute('aria-busy',primary.getAttribute('aria-busy') || 'false');
          button.textContent = primary.querySelector('[data-add-label]')?.textContent || primary.textContent;
        }
      };
      setups.set(form,sync);
      sync();
      const buttonObserver = new MutationObserver(sync);
      buttonObserver.observe(primary,{attributes:true,attributeFilter:['disabled','aria-busy']});
      if (dock) {
        const observer = new IntersectionObserver(() => {
          dock.hidden = primary.getBoundingClientRect().bottom >= 0;
        });
        observer.observe(primary);
        dock.querySelector('button').addEventListener('click',() => {
          if (primary.disabled) return;
          if (!form.reportValidity()) { form.scrollIntoView({block:'center',behavior:'smooth'}); return; }
          form.requestSubmit(primary);
        });
        const error = form.querySelector('[data-form-error]');
        if (error) new MutationObserver(() => { if (!error.hidden && !dock.hidden) error.scrollIntoView({block:'center',behavior:'smooth'}); }).observe(error,{attributes:true,attributeFilter:['hidden']});
      }
    });
  }
  const update = event => {
    const form = event.target.closest('form[data-purchase-ui]');
    if (form) queueMicrotask(() => setups.get(form)?.());
  };
  document.addEventListener('change',update);
  document.addEventListener('input',update);
  document.addEventListener('DOMContentLoaded',() => {
    init();
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) init(node); }))).observe(document.body,{childList:true,subtree:true});
  });
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

(() => {
  if (window.DGUnitPricingReady) return;
  window.DGUnitPricingReady = true;
  function update(scope, id) {
    scope.querySelectorAll('[data-variant-unit-price]').forEach(component => {
      const options = component.querySelector('[data-unit-price-options]')?.content;
      const match = options && [...options.querySelectorAll('[data-unit-variant]')].find(option => option.dataset.unitVariant === String(id));
      const label = component.querySelector('[data-unit-price-label]');
      if (!label) return;
      label.textContent = match?.dataset.unitLabel || '';
      label.title = match?.dataset.unitTitle || '';
      component.hidden = !label.textContent;
    });
  }
  function init(root = document) {
    const components = [...root.querySelectorAll('[data-variant-unit-price]')];
    if (root.matches?.('[data-variant-unit-price]')) components.push(root);
    for (const component of components) {
      const scope = component.closest('[data-product-scope]');
      if (!scope) continue;
      const selected = scope.querySelector('[data-variant-option]:checked,[data-demo-variant]:checked,[data-variant-select],[name="id"][type="hidden"]');
      if (selected) update(scope, selected.value);
    }
  }
  document.addEventListener('change', event => {
    const option = event.target.closest('[data-variant-option],[data-demo-variant],[data-variant-select]');
    const scope = option?.closest('[data-product-scope]');
    if (scope) update(scope, option.value);
  });
  const start = () => {
    init();
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) init(node); }))).observe(document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
